import { useQuery } from '@tanstack/react-query';
import type { ChainStoreContract } from '../../models/chain-store-contract.ts';
import { fetchChainStoreContract } from '../../api/chain-store-contract.ts';

export default function useChainStoreContract(
  partnerId: string,
  id: string,
  enabled: boolean = true,
) {
  return useQuery<ChainStoreContract>({
    queryKey: ['partner', partnerId, 'chainStoreContract', id],
    queryFn: async () => {
      const res = await fetchChainStoreContract(partnerId, id);
      return res.data;
    },
    enabled,
  });
}
